import HttpClient from './http';

export const getFiles = async (data) => {
  try {
    const resp = await HttpClient.get('google-drive/private', {
      params: data,
    });

    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const getPublicFiles = async (data) => {
  try {
    const resp = await HttpClient.get('google-drive/public', {
      params: data,
    });

    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const sendFile = async (formData) => {
  try {
    const resp = await HttpClient.post(
      'google-drive/private/upload-files',
      formData,
      {
        'Content-Type': 'multipart/form-data',
      }
    );
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const sendPublicFile = async (formData) => {
  try {
    const resp = await HttpClient.post(
      'google-drive/public/upload-files',
      formData,
      {
        'Content-Type': 'multipart/form-data',
      }
    );
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const sendFolder = async (data) => {
  try {
    const resp = await HttpClient.post('google-drive/private/new-folder', data);
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const sendPublicFolder = async (data) => {
  try {
    const resp = await HttpClient.post('google-drive/public/new-folder', data);
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const renameFile = async (data) => {
  try {
    const resp = await HttpClient.put('google-drive/edit-file-name', data);
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const deleteFile = async (data) => {
  try {
    const resp = await HttpClient.delete('google-drive/delete-files', {
      params: data,
    });
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};
